var map = {
	"./CH-PRESS.png": 153,
	"./JoeWilson.PNG": 83,
	"./Joe_Wilson.jpg": 189,
	"./LWC-PRESS1.png": 154,
	"./LWC-PRESS2.png": 155,
	"./Lee-Ackerman.jpg": 84,
	"./Madame Mayor.jpg": 156,
	"./about1.jpg": 50,
	"./about2.jpg": 51,
	"./about3.jpg": 65,
	"./about4.jpg": 66,
	"./aiota-logo.jpeg": 85,
	"./aiota-logo.png": 190,
	"./arcurve-logo.jpeg": 86,
	"./author1.jpg": 9,
	"./author2.jpg": 10,
	"./author3.jpg": 7,
	"./author4.jpg": 8,
	"./author5.jpg": 11,
	"./author6.jpg": 16,
	"./author7.jpg": 17,
	"./author8.jpg": 12,
	"./author9.jpg": 13,
	"./bg.jpg": 191,
	"./blog1.jpg": 18,
	"./blog2.jpg": 19,
	"./blog3.jpg": 33,
	"./blog4.jpg": 34,
	"./blog5.jpg": 67,
	"./blog6.jpg": 68,
	"./blog7.jpg": 192,
	"./brad-parry.png": 193,
	"./brad_parry_portrait.PNG": 157,
	"./buy-tickets-bg.jpg": 194,
	"./calgs-city-logo.png": 87,
	"./careers-logo.png": 88,
	"./cc-imging-logo.png": 89,
	"./ced-dev-logo-lg.png": 90,
	"./ced-logo.svg": 195,
	"./chicgeek.png": 91,
	"./color-bg.jpg": 196,
	"./daniel-huss.jpg": 197,
	"./daniel_mentor_edited.jpg": 92,
	"./daniel_mentor_headshot.jpeg": 198,
	"./educational-sponsor-bow-valley-college.png": 93,
	"./educational-sponsor-sait.png": 94,
	"./favicon.png": 199,
	"./funfacts-bg.jpg": 200,
	"./gold-partner1.png": 69,
	"./gold-partner2.png": 70,
	"./gold-partner3.png": 71,
	"./gold-partner4.png": 72,
	"./gold-partner5.png": 73,
	"./goodlawyer.png": 95,
	"./hackathon": 37,
	"./hackathon/": 37,
	"./hackathon/IMG_0307_Reduced.jpg": 96,
	"./hackathon/IMG_0315_Reduced.jpg": 97,
	"./hackathon/IMG_0331_Reduced.jpg": 98,
	"./hackathon/IMG_0370_Reduced.jpg": 99,
	"./hackathon/IMG_0373_Reduced.jpg": 100,
	"./hackathon/IMG_0374_Reduced.jpg": 101,
	"./hackathon/IMG_0381_Reduced.jpg": 102,
	"./hackathon/IMG_0389_Reduced.jpg": 103,
	"./hackathon/IMG_0402_Reduced.jpg": 104,
	"./hackathon/IMG_0408_Reduced.jpg": 105,
	"./hackathon/IMG_0415_Reduced.jpg": 106,
	"./hackathon/IMG_0436_Reduced.jpg": 107,
	"./hackathon/IMG_0446_Reduced.jpg": 108,
	"./hackathon/IMG_0451_Reduced.jpg": 109,
	"./hackathon/IMG_0467_Reduced.jpg": 110,
	"./hackathon/IMG_0509_Reduced.jpg": 111,
	"./hackathon/IMG_0519_Reduced.jpg": 112,
	"./hackathon/IMG_0543_Reduced.jpg": 113,
	"./hackathon/IMG_0569_Reduced.jpg": 114,
	"./hackathon/IMG_0572_Reduced.jpg": 115,
	"./hackathon/IMG_0578_Reduced.jpg": 116,
	"./hackathon/IMG_0595_Reduced.jpg": 117,
	"./hackathon/IMG_0616_Reduced.jpg": 118,
	"./hackathon/IMG_0641_Reduced.jpg": 119,
	"./hackathon/IMG_0682_Reduced.jpg": 120,
	"./hackathon/IMG_0691_Reduced.jpg": 121,
	"./hackathon/IMG_0698_Reduced.jpg": 122,
	"./hackathon/IMG_0709_Reduced.jpg": 123,
	"./hackathon/IMG_0718_Reduced.jpg": 124,
	"./hackathon/IMG_0731_Reduced.jpg": 125,
	"./hackathon/IMG_0755_Reduced.jpg": 126,
	"./hackathon/IMG_0783_Reduced.jpg": 127,
	"./hackathon/IMG_0802_Reduced.jpg": 128,
	"./hackathon/IMG_0804_Reduced.jpg": 129,
	"./hackathon/IMG_0816_Reduced.jpg": 130,
	"./hackathon/IMG_0829_Reduced.jpg": 131,
	"./hackathon/index": 37,
	"./hackathon/index.js": 37,
	"./harvest-logo.png": 132,
	"./helcim.png": 133,
	"./ian_judge_headshot.jpeg": 62,
	"./it-iq-logo.jpg": 134,
	"./jasmine-judge.jpeg": 135,
	"./kellie_judges_headshot.jpeg": 63,
	"./keynote-mayor.jpg": 201,
	"./logo.png": 61,
	"./main-bg1.jpg": 202,
	"./main-bg2.jpg": 203,
	"./main-bg3.jpg": 204,
	"./main-bg4.jpg": 205,
	"./main-bg5.jpg": 206,
	"./manpower-logo.png": 136,
	"./micky-mentor.png": 137,
	"./patt.png": 207,
	"./pixeltree-logo.png": 138,
	"./placeholder.jpeg": 208,
	"./placeholder_image.jpeg": 54,
	"./platform-logo.png": 139,
	"./platinum-partner1.png": 74,
	"./platinum-partner2.png": 75,
	"./platinum-partner3.png": 76,
	"./platinum-partner4.png": 77,
	"./platinum-partner5.png": 78,
	"./rainforest.jpeg": 140,
	"./retrain-canada-logo.png": 141,
	"./ryan_corry_mentor.jpg": 142,
	"./shapes/1.png": 26,
	"./shapes/2.png": 27,
	"./shapes/3.png": 28,
	"./shapes/4.png": 29,
	"./shapes/5.png": 52,
	"./signature.png": 36,
	"./slider-bg1.jpg": 209,
	"./slider-bg2.jpg": 210,
	"./slider-bg3.jpg": 211,
	"./slideshow-bg1.jpg": 212,
	"./slideshow-bg2.jpg": 213,
	"./slideshow-bg3.jpg": 214,
	"./slideshow-bg4.jpg": 215,
	"./speakers1.jpg": 39,
	"./speakers2.jpg": 40,
	"./speakers3.jpg": 41,
	"./speakers4.jpg": 42,
	"./speakers5.jpg": 43,
	"./speakers6.jpg": 44,
	"./speakers7.jpg": 46,
	"./speakers8.jpg": 47,
	"./speakers9.jpg": 216,
	"./startup-tnt-logo.png": 143,
	"./vantage-circle-logo.png": 144,
	"./vog-logo.png": 145,
	"./vog-lp-logo.png": 146,
	"./why-choose-img1.jpg": 55,
	"./why-choose-img2.jpg": 56,
	"./why-choose-img3.jpg": 57,
	"./yyc-data-logo.svg": 147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;